var React = require('react');

function DownArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#FFF","strokeWidth":"1.4","fill":"none","fillRule":"evenodd"},[React.createElement("path",{"strokeLinecap":"square","d":"M14.3.925v32.55","key":0}),React.createElement("path",{"d":"M1.3 20.884L14.03 33.42l12.73-12.535","key":1})]));
}

DownArrow.defaultProps = {"width":"28","height":"35"};

module.exports = DownArrow;

DownArrow.default = DownArrow;
